import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getTimes } from "../services/time";

export const useTimes = (
  input: { project?: string } & ({ from: Date; to: Date } | { date: Date }),
  cacheKey?: string,
) => {
  const queryKey = [
    "get-times",
    ...(cacheKey
      ? [cacheKey]
      : "date" in input
        ? [input.date]
        : [input.from, input.to]),
    ...(input.project ? [input.project] : []),
  ];
  return useQuery({
    queryKey,
    queryFn: () => getTimes(input),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
};
